export default class ESGTemplateDTO {
  constructor({
    id = null,
    name = "",
    description = "",
    templateType = "",
    appliesTo = "",
    reportingFrequency = "",
    sections = [],
    taxonomyBindings = [],
    version = 1,
    isActive = true
  } = {}) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.templateType = templateType;
    this.appliesTo = appliesTo;
    this.reportingFrequency = reportingFrequency;
    this.sections = sections;
    this.taxonomyBindings = taxonomyBindings;
    this.version = version;
    this.isActive = isActive;
  }
}